import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import userReducer from './userReducer'
import categoryReducer from './categoryReducer'
import menuReducer from './menuReducer'
import orderReducer from './orderReducer'
import outletReducer from './outletReducer'
import promoCodeReducer from './promoCodeReducer'
import metaReducer from './metaReducer'

import { loadCategories } from '../actions/categoryAction'

const composeEnhanchers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    combineReducers({
        user: userReducer,
        categories: categoryReducer,
        menu: menuReducer,
        outlets: outletReducer,
        myOrders: orderReducer,
        promoCodes: promoCodeReducer,
        meta: metaReducer
    }),
    composeEnhanchers(applyMiddleware(thunk))
)

let currentState = store.getState()

store.subscribe(() => {
    // keep track of the previous and current state to compare changes
    let previousState = currentState;
    currentState = store.getState();
    // =============================================
    // filters calculations here
    // =============================================

    let searchText1 = previousState.meta.searchText
    let searchText2 = currentState.meta.searchText

    let foodPref1 = previousState.meta.foodPref
    let foodPref2 = currentState.meta.foodPref

    if (searchText1 !== searchText2 || foodPref1 !== foodPref2) {

        const categories = { ...currentState.categories }

        const menu = currentState.menu
        // ==================================
        //  making category sections here   
        // ==================================
        // const categoryData = []

        const searchText = currentState.meta.searchText
        const foodPref = currentState.meta.foodPref

        for (let key in categories) {

            const catId = categories[key].id
            categories[key].items = []
            for (let menuKey in menu) {
                const menuCats = menu[menuKey].category
                const foodItem = menu[menuKey]

                for (let i = 0; i < menuCats.length; i++) {
                    const menuCatValue = menuCats[i].value

                    if (foodItem.title.toLowerCase().includes(searchText.trim().toLowerCase()) && menuCatValue === catId) {
                        if (foodPref === foodItem.type) {
                            categories[key].items.push(menuKey)
                        } else if (foodPref === 'ALL') {
                            categories[key].items.push(menuKey)
                        }
                    }
                }

            }

        }

        store.dispatch(loadCategories(categories))


        // categoryData.push(categories[key])


    }

});





export default store